module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "composite"
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5dfad989"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/table-field/FieldComposite.vue
// module id = 689
// module chunks = 0